import { Box, Paper, styled, Typography, Modal, Button } from '@mui/material';
import Fade from '@mui/material/Fade';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ImponibleData } from '../features/imponibles/imponiblesAPI';
import {
  statusImponible,
  unlinkImponible,
} from '../features/imponibles/imponiblesSlice';
import { store } from '../store';
import { getUnreadNotNumber } from '../features/notificaciones/notificacionesSlice';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  boxShadow: 24,
  padding: '2rem 2rem 2rem 2rem',
};

const ModalWrapper = styled(Paper)(({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  textAlign: 'center',
}));

interface PlanProps {
  openModal: boolean;
  setOpenModal: (v: boolean) => void;
  title: string;
  text: string;
  imponible: ImponibleData;
}

export default function ConfirmModal(props: PlanProps) {
  const { openModal, setOpenModal, title, text, imponible } = props;

  const status = useSelector(statusImponible);
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'success') {
      navigate('/');
    }
  }, [status]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(!openModal)}
        closeAfterTransition
      >
        <Fade in={openModal}>
          <ModalWrapper sx={style}>
            <Box mb={3}>
              <Typography>
                <strong>{title}</strong>
              </Typography>

              <Typography variant="body2" my={2}>
                {text}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  store.dispatch(unlinkImponible(imponible.id))
                    .unwrap()
                    .then(() => store.dispatch(getUnreadNotNumber()));
                }}
                sx={{
                  color: 'white',
                  width: '40%',
                }}
              >
                Continuar
              </Button>
              <Button
                variant="outlined"
                sx={{ width: '40%' }}
                onClick={() => setOpenModal(!openModal)}
              >
                Cancelar
              </Button>
            </Box>
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
}
